export const CERTIFICATE_TYPES = [
  "Recognition",
  "Excellence",
  "Achievement",
  "Service",
  "Appreciation",
  "Commendation",
  "Training",
  "Custom",
];

export const CERTIFICATE_TITLE_BY_TYPE = {
  Recognition: "Certificate of Recognition",
  Excellence: "Certificate of Excellence",
  Achievement: "Certificate of Achievement",
  Service: "Certificate of Service",
  Appreciation: "Certificate of Appreciation",
  Commendation: "Certificate of Commendation",
  Training: "Certificate of Training Achievement",
  Custom: "Certificate of Recognition",
};

export function formatCertificateDate(value) {
  if (!value) return "Not recorded";
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00Z`);
  if (!Number.isFinite(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(date);
}

export async function openCertificatePdf({ certificate, session, download = false }) {
  if (!certificate?.id || !session?.access_token) throw new Error("Certificate session is unavailable.");

  if (!download) {
    const fromManagement = window.location.pathname.startsWith("/intranet/management/");
    const path = `/intranet/certificates/${encodeURIComponent(certificate.id)}/pdf${fromManagement ? "?from=management" : ""}`;
    const canonicalUrl = `https://ruht.cloud${path}`;
    const popup = window.open(canonicalUrl, "_blank", "noopener,noreferrer");
    if (!popup) throw new Error("Your browser blocked the certificate window. Allow pop-ups and try again.");
    return;
  }

  const response = await fetch(`/api/certificates?action=pdf&id=${encodeURIComponent(certificate.id)}&download=1`, {
    headers: { Authorization: `Bearer ${session.access_token}` },
  });
  if (!response.ok) {
    let message = "Unable to retrieve certificate PDF.";
    try { message = (await response.json())?.error || message; } catch {}
    throw new Error(message);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = certificate.pdf_file_name || `${certificate.certificate_number || "certificate"}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
